// @flow

import Unit from '@/lib/unit';
import Condition from '@/lib/condition';

export default class {
  static process(unit: Unit) {
    if (!unit.template.die) return;

    const { die } = unit.template;

    for (let i = 0; i < die.conditions.length; i++) {
      const condition = die.conditions[i];
      const value = unit.getParameter(condition[0], condition[1]);

      if (new Condition(condition[2]).judge(value)) {
        unit.status = 'dead';
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/unit_event/die_event.js